import { Link } from "react-router-dom";
import type { Article } from "@/types/content";
import { categories } from "@/mocks/categories";

interface ArticleBodyProps {
  article: Article;
}

export default function ArticleBody({ article }: ArticleBodyProps) {
  const catName =
    categories.find((item) => item.slug === article.category)?.name ?? "热瓜";

  return (
    <article className="min-w-0">
      <div className="rounded-lg overflow-hidden border border-background-200 mb-6 md:mb-8">
        <img
          src={article.cover}
          alt={`${article.title} - 瓜友会网${catName}爆料现场配图`}
          title={`${article.title} - 瓜友会网`}
          className="w-full h-56 md:h-96 object-top object-cover"
        />
      </div>

      <div className="space-y-4 md:space-y-5 text-sm md:text-base leading-loose text-foreground-700">
        {article.content.map((paragraph, index) => (
          <p
            key={`${article.id}-p-${index}`}
            dangerouslySetInnerHTML={{ __html: paragraph }}
          />
        ))}
      </div>

      <div className="mt-8 rounded-lg bg-accent-50 border border-accent-200 p-5 md:p-6">
        <h2 className="text-base font-bold text-accent-950 flex items-center gap-2 mb-2">
          <i className="ri-information-line" aria-hidden="true"></i>
          围观提醒
        </h2>
        <p className="text-sm text-accent-950/75 leading-relaxed">
          本文内容为公开网络信息的整理与转述，仅供讨论交流，不构成任何事实认定。
          事件仍在进展中，建议结合官方口径一起判断，理性吃瓜。
        </p>
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-2">
        <span className="text-sm text-foreground-400 mr-1">相关标签</span>
        {article.tags.map((tag) => (
          <Link
            key={tag}
            to={`/?q=${encodeURIComponent(tag)}`}
            className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-600 hover:border-primary-200 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            #{tag}
          </Link>
        ))}
      </div>
    </article>
  );
}